// extracted by mini-css-extract-plugin
module.exports = {"root":"header_root__3gIJ-","title":"header_title__13zzp"};